import { RadioGroup, RadioGroupItem, Label, Typography, Stack } from "@altimateai/lego";
import { Privacy } from "@/helpers/constants";
import { PrivacyLevel } from "@/types";

interface PrivacySelectorProps {
  value: PrivacyLevel;
  onValueChange: (value: PrivacyLevel) => void;
  entityType?: string;
}

export const PrivacySelector = ({
  value,
  onValueChange,
  entityType = "resource",
}: PrivacySelectorProps) => {
  return (
    <div className="al-space-y-2">
      <Typography variant="h4" weight="semibold">
        Privacy
      </Typography>
      <RadioGroup value={value} onValueChange={onValueChange} className="al-space-y-4">
        <Stack align="start" className="al-space-x-3">
          <RadioGroupItem value={Privacy.PRIVATE} id="private" className="al-mt-1" />
          <div className="al-grid al-gap-1.5 al-leading-none">
            <Label
              htmlFor="private"
              className="al-text-sm al-font-medium al-leading-none al-peer-disabled:cursor-not-allowed al-peer-disabled:opacity-70"
            >
              Private
            </Label>
            <Typography variant="body" size="sm" className="al-text-muted-foreground">
              Only you can access and use this {entityType}
            </Typography>
          </div>
        </Stack>
        <Stack align="start" className="al-space-x-3">
          <RadioGroupItem value={Privacy.PUBLIC} id="public" className="al-mt-1" />
          <div className="al-grid al-gap-1.5 al-leading-none">
            <Label
              htmlFor="public"
              className="al-text-sm al-font-medium al-leading-none al-peer-disabled:cursor-not-allowed al-peer-disabled:opacity-70"
            >
              Public
            </Label>
            <Typography variant="body" size="sm" className="al-text-muted-foreground">
              All members of your organization can access and use this {entityType}
            </Typography>
          </div>
        </Stack>
      </RadioGroup>
    </div>
  );
};
